import React from "react";

// Arrow icon SVG component
const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
      fill="#FC7600"
    />
  </svg>
);

const WebsiteFeaturesBanner = ({
  title,
  description,
  image,
  imageAlt,
  websiteFeaturesTitle,
  websiteFeatures,
  adminPanelTitle,
  adminFeatures,
}) => {
  return (
    <section className="hero-section-main d-flex align-items-center">
      <div className="container">
        <h2 className="tech-stack-title text-center">{title}</h2>
        <p className="tech-stack-description text-center">{description}</p>
        <div className="row">
          <div className="col-lg-6 hero-image text-center mt-2 mt-lg-0">
            <div className="portfolio-device-mockups portfolio-details-img justify-content-start">
              <img
                src={image}
                alt={imageAlt || "Website Features"}
                className="portfolio-hero-img"
              />
            </div>
          </div>
          <div className="col-lg-6 portfolio-hero-content mt-4">
            {websiteFeatures && websiteFeatures.length > 0 && (
              <div className="features">
                <h3 className="heding">{websiteFeaturesTitle}</h3>
                <ul className="features-list">
                  {websiteFeatures.map((feature, index) => (
                    <li className="tecno-hedding" key={index}>
                      <ArrowIcon />
                      <div>{feature}</div>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {adminFeatures && adminFeatures.length > 0 && adminPanelTitle && (
              <div className="features">
                <h3 className="heding">{adminPanelTitle}</h3>
                <ul className="features-list">
                  {adminFeatures.map((feature, index) => (
                    <li className="tecno-hedding" key={index}>
                      <ArrowIcon />
                      <div>{feature}</div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteFeaturesBanner;
